import { Button, Card, Space, Popconfirm, message } from "antd";
import React, { useEffect, useRef, useState } from "react";

import {
  EditOutlined,
  DeleteOutlined,
  DownloadOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import AddAuthorisationLetter from "./AddAuthorisationLetter";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import TableComponent from "../common/TableComponent";
import AuthorisationLetterPrint from "./AuthorisationLetterPrint";
import { useReactToPrint } from "react-to-print";

function AuthorisationLetterTable() {
  const isMobile = useMediaQuery({ maxWidth: 950 });
  const [messageApi, contextHolder] = message.useMessage();
  const [confirmDeletePCLoading, setConfirmDeletePCLoading] = useState(false);
  let columns = [
    {
      title: "Company Name",
      dataIndex: "company_name",
    },
    {
      title: "From Date",
      dataIndex: "from_date",
      isMobile: isMobile,
    },
    {
      title: "To Date",
      dataIndex: "to_date",
      isMobile: isMobile,
    },
    {
      title: "Authorised By",
      dataIndex: "created_by_name",
      isMobile: isMobile,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          <Space>
            <Button size="small" onClick={() => editRecord(record)}>
              <EditOutlined />
            </Button>
            <Button size="small" onClick={() => { setSelectedRecord(record); handlePrint(); }}>
              <PrinterOutlined />
            </Button>
            <Popconfirm
              title="Delete Letter"
              description={`Are you sure to delete this?`}
              onConfirm={() => deleteRecord(record)}
              trigger={"click"}
              okButtonProps={{
                loading: confirmDeletePCLoading,
              }}
              placement="rightTop"
            >
              <Button size="small">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </Space>
        </>
      ),
    },
  ];

  if (isMobile) {
    columns = columns.filter((c) => !c.isMobile);
  }

  const [responseData, getRequest] = useApi(
    `/authorisation-letter?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );
  const [deleteResponse, deleteRequest] = useApi();
  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState();
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "Autorisation Letter",
    onAfterPrint: () => console.log('Printed PDF successfully!'),
  });

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
    data && setSelectedRecord(data[0]);
  }, [responseData]);

  useEffect(() => {
    if (deleteResponse.data && !deleteResponse.isLoading) {
      getRequest();
      setCurrentPage(1);
      setConfirmDeletePCLoading(false);
      messageApi.open({
        type: "success",
        content: "Authorisation Deleted successfully",
      });
    }
  }, [deleteResponse]);

  const handleAddLetter = (isUpdated) => {
    const flag = visible ? false : true;
    setVisible(flag);
    if (isUpdated === true) {
      getRequest();
      setCurrentPage(1);
    }
  };

  const handleEditLetter = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest();
      setCurrentPage(1);
    }
  };

  const editRecord = (record) => {
    setVisibleEdit(true);
    setSelectedRecord(record);
  };

  const download = (record) => {
    setSelectedRecord(record);
  };

  const deleteRecord = (record) => {
    setConfirmDeletePCLoading(true);
    deleteRequest(
      null,
      API_METHODS.DELETE,
      `/authorisation-letter/${record.id}`
    );
  };

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/authorisation-letter?pageNumber=${page.current}`
    );
    setCurrentPage(page.current);
  };

  return (
    <Card
      title="Authorisation Letters"
      extra={
        <Button type="primary" onClick={handleAddLetter}>
          Add Authorisation
        </Button>
      }
    >
      {contextHolder}
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />
      {visible && (
        <AddAuthorisationLetter visible={visible} close={handleAddLetter} />
      )}
      {visibleEdit && (
        <AddAuthorisationLetter
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditLetter}
        />
      )}

      {selectedRecord &&
        <div style={{ visibility: "hidden", display: "none" }} ><AuthorisationLetterPrint componentRef={componentRef} data={selectedRecord} /></div>
      }

    </Card>
  );
}

export default AuthorisationLetterTable;
